export const maxCharsValueFormat = ({ cell: { value } }: any) => {
  const maxChars = 100
  const valueString = value as string
  const isLonger = valueString?.length > maxChars
  return (
    <>{valueString?.substring(0, maxChars).concat(isLonger ? '...' : '')}</>
  )
}
